import { useEffect } from "react";
import classNames from "classnames";

export const CDrawer = ({ open, onClose, direction = "left", children }) => {
  useEffect(() => {
    if (open) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [open]);

  //#region Event
  // Xác định class transform theo direction
  const getDrawerTransform = () => {
    switch (direction) {
      case "right":
        return open ? "translate-x-0" : "translate-x-full";
      case "top":
        return open ? "translate-y-0" : "-translate-y-full";
      case "bottom":
        return open ? "translate-y-0" : "translate-y-full";
      case "left":
      default:
        return open ? "translate-x-0" : "-translate-x-full";
    }
  };

  // Xác định vị trí cố định của drawer theo direction
  const getDrawerPosition = () => {
    switch (direction) {
      case "right":
        return "right-0 top-0 h-full";
      case "top":
        return "top-0 left-0 w-full";
      case "bottom":
        return "bottom-0 left-0 w-full";
      case "left":
      default:
        return "left-0 top-0 h-full";
    }
  };
  //#endregion

  //#region Render
  return (
    <div
      className={classNames(
        "fixed h-dvh w-dvw inset-0 backdrop-blur-[1px] transition-all duration-300 ease-in-out",
        open
          ? "z-50 select-auto pointer-events-auto bg-black/15 visible overflow-hidden"
          : "-z-50 select-none pointer-events-none bg-transparent invisible"
      )}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={classNames(
          "fixed bg-white shadow-lg transition-transform duration-300 ease-in-out",
          getDrawerPosition(),
          getDrawerTransform()
        )}
        style={{
          minWidth:
            direction === "left" || direction === "right" ? 360 : undefined,
          minHeight:
            direction === "top" || direction === "bottom" ? 240 : undefined,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
  //#endregion
};
